/**
 * The CRM live AI demo signs the company portal in, inside an iframe on the
 * CRM host, as a read-only viewer of a fictional demo company. The sign-in
 * lands with `live_demo=1`; the flag lives for the tab so the portal skips
 * its first-visit product tours, which would cover what the AI is showing.
 */
export const LIVE_DEMO_SESSION_KEY = 'KollabHR:liveDemo';

export function isLiveDemoSession(): boolean {
  try {
    return (
      window.self !== window.top &&
      sessionStorage.getItem(LIVE_DEMO_SESSION_KEY) === '1'
    );
  } catch {
    return false;
  }
}
